import { syncRepository, type MarkupSettings, type SyncStatus, type SyncLog } from '../../infrastructure/repositories/SyncRepository';

export class SyncService {
  async getSettings(): Promise<MarkupSettings> {
    return syncRepository.getSettings();
  }

  async updateSettings(settings: Partial<MarkupSettings>): Promise<void> {
    await syncRepository.updateSettings(settings);
  }

  async triggerSync(): Promise<void> {
    await syncRepository.triggerSync();
  }

  async getStatus(): Promise<SyncStatus> {
    return syncRepository.getStatus();
  }

  async getLogs(): Promise<SyncLog[]> {
    const resp = await syncRepository.getLogs();
    return resp.logs || [];
  }

  async cancelSync(): Promise<void> {
    await syncRepository.cancelSync();
  }

  async refreshProducts(skus?: string[]): Promise<void> {
    await syncRepository.refreshProducts(skus);
  }
}

export const syncService = new SyncService();
